import { AgenciaOrcamentoPolicy } from './agenciaOrcamentoPolicy';
import { ImpostoNfAccessPorFornecedorPolicy } from './impostoNfAccessPorFornecedorPolicy';
import { OrcamentoClientInheritance } from './orcamentoClientInheritance';
import { CAMPO_SOMA_SEM_ARREDONDAR } from './valorBrlPolicy';

// Modelo de regras "longping" (D-0119, Rafael 27/10; as planilhas da Forseed são a referência):
// - linha com fornecedor Access e a linha FEE AGÊNCIA 130 levam % Imposto NF 19,05 (gross-up no total
//   da linha); linha de outro fornecedor sai sem NF;
// - a linha FEE AGÊNCIA sem fornecedor recebe a Access: sem ela a NF do FEE seria zerada;
// - base do FEE = total da linha (feeBaseInternacionalPolicy, baseComTotalLinha).
// O % do FEE vem da regra cadastrada no cliente (7,2%); a Coordenação Logística fica fora porque o
// operador desmarca Compõe FEE. Espelho de App\Services\OrcamentoLongPingPolicy (API).
export const MODELO_LONG_PING = 'longping';
export const IMPOSTO_NF_LONG_PING = '19.05';

export function ehClienteLongPing(cliente) {
    if (!cliente || typeof cliente !== 'object') return false;
    return OrcamentoClientInheritance.resolveRuleModel(cliente) === MODELO_LONG_PING;
}

// Total como a planilha (Rafael 27/10: "tem que bater no centavo"): FEE com 6 casas e somas sem arredondar
// por linha. Só em Real; em moeda estrangeira vale o R$ exato de sempre. Espelho de OrcamentoLongPingPolicy::somaSemArredondar.
export function somaSemArredondar(cliente, moeda) {
    return ehClienteLongPing(cliente) && String(moeda ?? 'real').trim().toLowerCase() === 'real';
}

// Marca (ou desmarca) a linha para entrar nas somas pelo total sem arredondar (valorBrlPolicy.valorBrlLinha).
function marcarSomaSemArredondar(subitem = {}, ligado = false) {
    if (ligado) subitem[CAMPO_SOMA_SEM_ARREDONDAR] = true;
    else delete subitem[CAMPO_SOMA_SEM_ARREDONDAR];
    return subitem;
}

// Muta a linha, como ImpostoNfAccessPorFornecedorPolicy.normalizarSubitem. Linha de imposto 1945 fica como está.
function normalizarSubitem(subitem = {}, fornecedorAccess = null) {
    const produto = subitem.produto ?? {};
    if (String(produto.codigo ?? '').trim() === '1945') return subitem;
    if (AgenciaOrcamentoPolicy.isFeeAgenciaGlobal(produto) && !subitem.fornecedor?.id && fornecedorAccess?.id) {
        subitem.fornecedor = { id: fornecedorAccess.id, nome: fornecedorAccess.nome, cnpj: fornecedorAccess.cnpj };
    }
    subitem.imposto = ImpostoNfAccessPorFornecedorPolicy.fornecedorEhAccess(subitem, fornecedorAccess)
        ? IMPOSTO_NF_LONG_PING
        : '0';
    return subitem;
}

export const LongPingPolicy = {
    ehClienteLongPing,
    somaSemArredondar,
    marcarSomaSemArredondar,
    normalizarSubitem,
};
